<template>
  <modal id="remove-mup-member-modal" :modifiers="['no-horizontal-padding']">
    <div class="w-screen max-w-md pt-12 px-6 pb-6">
      <b-headline type="h2" typography="h2">
        {{ $t("headline", { email: userEmail }) }}
      </b-headline>
      <p class="mb-8" v-html="noticeText" />
      <div class="flex justify-between items-center">
        <a class="cursor-pointer" @click="close">
          {{ $t("cancel") }}
        </a>
        <b-button @click="submit">
          {{ $t("continue") }}
        </b-button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/shared/modal"
import BHeadline from "@/component-library/b-headline/index"
import BButton from "@/component-library/b-button/index"
import events from "@/bl-events/index"

/**
 * @emits submit
 */
export default {
  name: "RemoveMupMemberModal",
  components: {
    BHeadline,
    BButton,
    Modal
  },
  props: {
    userEmail: {
      type: String,
      default: null
    }
  },
  computed: {
    noticeText() {
      return this.$t("noticeText", { email: this.userEmail })
    }
  },
  methods: {
    close() {
      events.emit("modal:remove-mup-member-modal:close")
    },
    submit() {
      this.close()
      this.$emit("submit", this.account)
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Are you sure you want to remove {email}",
        noticeText:
          "Removing {email} from your Blinkist Connect means that they’ll no longer have access to Blinkist Premium. You will then be able to invite someone else to your Premium plan again on Blinkist Connect.",
        cancel: "Cancel",
        continue: "Continue"
      },
      de: {
        headline: "Möchtest du {email} wirklich entfernen?",
        noticeText:
          "{email} hat dann keinen Zugriff mehr auf Blinkist Connect und ihr könnt keine Titel mehr miteinander teilen. Du kannst aber jederzeit eine:n andere:n Freund:in zu Blinkist Connect einladen.",
        cancel: "Abbrechen",
        continue: "Weiter"
      }
    }
  }
}
</script>
